import { Controller } from "@hotwired/stimulus";
import { createAdObserver } from '../utils/adUtils'

/**
 * Controller to fix ad links in native app context
 * Removes target="_blank" from links when in native app
 */
export default class extends Controller {
  /** @type {MutationObserver} */
  #observer

  connect() {
    const rootNode = document.getRootNode()
    const isNativeApp =
      rootNode.documentElement?.getAttribute('data-turbo-native-app') === 'true'

    if (isNativeApp) {
      this.#observer = createAdObserver(
        this.element,
        (mutationList, observer) => {
          const links = this.element.querySelectorAll('a[target="_blank"]')
          if (links.length > 0) {
            links.forEach((link) => link.removeAttribute('target'))
          }
        },
      )
    }
  }

  /**
   * Clean up when the controller is disconnected
   */
  disconnect() {
    if (this.#observer) {
      this.#observer.disconnect()
    }
  }
}
